export var BANK_PHONE_NUMBER = '1-877-247-2559';
export var CLOSING_FEE = 25;
export var DATE_PICKER_FORMAT = 'MM/DD/YYYY';
export var DEFAULT_NEW_CUSTOMER_LIMIT = 10000;
export var DELIVERY_DATE_ADVANCE_DAYS = 364;
export var DURATION_DATE_ADVANCE_YEARS = 5;
export var INTERNAL_LIMIT = 1000000;
export var SERVER_DATE_FORMAT = 'YYYY-MM-DD';
export var SERVER_TIMEZONE = 'America/New_York';
export var oneTime = {
    value: '0',
    name: 'One-Time Transfer',
    serviceName: 'ONE_TIME',
    interval: [0, 'days'],
};
export var oneWeek = {
    value: '1',
    name: 'Every Week',
    serviceName: 'WEEKLY',
    interval: [1, 'weeks'],
};
export var twoWeeks = {
    value: '2',
    name: 'Every 2 Weeks',
    serviceName: 'BIWEEKLY',
    interval: [2, 'weeks'],
};
export var fourWeeks = {
    value: '4',
    name: 'Every 4 Weeks',
    serviceName: 'FOUR_WEEKS',
    interval: [4, 'weeks'],
};
export var fifteenDays = {
    value: '3',
    name: 'Every 15 Days',
    serviceName: 'FORTNIGHTLY',
    interval: [15, 'days'],
};
export var oneMonth = {
    value: '5',
    name: 'Every Month',
    serviceName: 'MONTHLY',
    interval: [1, 'months'],
};
export var twoMonths = {
    value: '8',
    name: 'Every 2 Months',
    serviceName: 'BIMONTHLY',
    interval: [2, 'months'],
};
export var threeMonths = {
    value: '9',
    name: 'Every 3 Months',
    serviceName: 'QUARTERLY',
    interval: [3, 'months'],
};
export var fourMonths = {
    value: '10',
    name: 'Every 4 Months',
    serviceName: 'FOUR_MONTHS',
    interval: [4, 'months'],
};
export var sixMonths = {
    value: '11',
    name: 'Every 6 Months',
    serviceName: 'SIX_MONTHS',
    interval: [6, 'months'],
};
export var oneYear = {
    value: '12',
    name: 'Every Year',
    serviceName: 'YEARLY',
    interval: [1, 'years'],
};
export var firstBusinessDay = {
    value: '6',
    name: 'First Business Day of Every Month',
    serviceName: 'FIRST_BUSINESS_DAY_OF_MONTH',
    interval: [1, 'months'],
};
export var lastBusinessDay = {
    value: '7',
    name: 'Last Business Day of Every Month',
    serviceName: 'LAST_BUSINESS_DAY_OF_MONTH',
    interval: [1, 'months'],
};
export var scheduleATransfer = {
    value: '13',
    name: 'Schedule a Transfer',
    /**
     * This frequency is purely cosmetic, so these values do not matter
     */
    serviceName: '',
    interval: [0, 'days'],
};
export var allFrequencies = [
    oneTime,
    oneWeek,
    twoWeeks,
    fourWeeks,
    fifteenDays,
    oneMonth,
    twoMonths,
    threeMonths,
    fourMonths,
    sixMonths,
    oneYear,
    firstBusinessDay,
    lastBusinessDay,
];
/**
 * Frequencies for internal transfers.
 */
export var internalFrequencies = [
    oneTime,
    oneWeek,
    twoWeeks,
    oneMonth,
    twoMonths,
    threeMonths,
    fourMonths,
    sixMonths,
    oneYear,
];
/**
 * Frequencies for external (non-invest) transfers.
 */
export var externalFrequencies = [
    oneTime,
    oneMonth,
    fifteenDays,
    oneWeek,
    twoWeeks,
    fourWeeks,
    twoMonths,
    threeMonths,
    sixMonths,
    oneYear,
    firstBusinessDay,
    lastBusinessDay,
];
/**
 * Frequencies for invest transfers.
 */
export var investFrequencies = [
    oneTime,
    oneWeek,
    twoWeeks,
    oneMonth,
    threeMonths,
    oneYear,
];
export var iraWithdrawalFrequencies = [
    oneTime,
    scheduleATransfer,
];
export var TransferDurationLabels;
(function (TransferDurationLabels) {
    TransferDurationLabels["MANUAL"] = "When I cancel";
    TransferDurationLabels["DATE"] = "On a specified date";
    TransferDurationLabels["AMOUNT"] = "When I reach a specified amount";
    TransferDurationLabels["QUANTITY"] = "After a specified number of transfers";
})(TransferDurationLabels || (TransferDurationLabels = {}));
export var TransferDurationValues;
(function (TransferDurationValues) {
    TransferDurationValues["MANUAL"] = "manual";
    TransferDurationValues["DATE"] = "date";
    TransferDurationValues["AMOUNT"] = "amount";
    TransferDurationValues["QUANTITY"] = "quantity";
})(TransferDurationValues || (TransferDurationValues = {}));
var manualCancel = {
    label: TransferDurationLabels.MANUAL,
    value: TransferDurationValues.MANUAL,
};
var specifiedDate = {
    label: TransferDurationLabels.DATE,
    value: TransferDurationValues.DATE,
};
var specifiedAmount = {
    label: TransferDurationLabels.AMOUNT,
    value: TransferDurationValues.AMOUNT,
};
var specifiedTransfers = {
    label: TransferDurationLabels.QUANTITY,
    value: TransferDurationValues.QUANTITY,
};
/**
 * End field options.
 */
export var durationOptions = {
    INTERNAL: [manualCancel, specifiedDate],
    EXTERNAL: [manualCancel, specifiedDate, specifiedAmount, specifiedTransfers],
};
/**
 * Error messages
 */
export var CATCH_ALL_ERROR_MESSAGE = "We can't complete your request right now. Try again later.";
export var SAVE_TRANSFER_ERROR_CODES = {
    USB_SYS_058: "We're unable to process your request at this time. Please call us 24/7 at 1-877-247-2559 for help.",
    USB_BUS_193: 'You can no longer schedule a transfer to be sent today because the cutoff time (1:00 AM ET) has passed. Please change your send date.',
    USB_BUS_194: 'You can no longer schedule a transfer to be sent today because the cutoff time (7:30 PM ET) has passed. Please change your send date.',
    USB_BUS_195: "We can't make this transfer due to current restrictions on your account. You need to call us at 1-877-247-2559 (ALLY) to resolve this issue. We're here 24/7.",
    USB_BUS_136: "Your transfer details aren't available right now. Please check back later.",
    USB_BUS_131: "We can't process this transfer because it exceeds our limit for this financial institution. Call us at 1-877-247-2559 for help.",
    USB_BUS_129: 'This amount exceeds your transfers limit',
};
export var SAVE_TRANSFER_EXCEPTION_CODES = {
    USB_BUS_068: 'Your internal transfer was completed. Due to system maintenance, you may not see this transfer displayed immediately in Account Details. Please check back later.',
};
export var ALLOW_TWO_TRANSFERS_ERROR_MESSAGE = 'Could not complete the funds transfer since the requested duration is less than 2 transfers.';
//# sourceMappingURL=constants.js.map